module.exports = function () {
    return {
        restrict: 'E',
        transclude: true,
        link(scope, element, iAttrs, controller, transcludeFn) {
            transcludeFn((clone) => {
                element.append(clone);
            });

            const selectLabel = element.find('label');
            if (selectLabel && selectLabel.length) {
                selectLabel.addClass('olySelect-label');
                element.find('select').addClass('olySelect-select wowInput');
            } else {
                element.find('select').addClass('olySelect-selectNoLabel wowInput');
            }
        },
        template: '<i class="olySelect-icon iconww-ArrowDown"></i>',
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/select/select.directive.js